export default "<agents-list\n  (reloadAgents)=\"reloadAgents($event)\"\n  [initialAgentsSet]=\"initialAgents\">\n</agents-list>\n";